import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { uid_download } from '../../input_output';
import save_svg from '../../../assets/img/SVG_icons/Right/import-export/save.svg';
import { img } from '@phi/components';
import { IAuthentication } from '@phi/authentication/frontend';
import DownloadTooltip from './DownloadTooltip';

export const DownloadIcon = save_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        auth: { required: true, type: Object as PropType<IAuthentication> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Save/download file';
        },

        disabled() {
            return !this.state.loaded;
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else if (this.state.is_demo)
                this.auth.show_must_login_modal();
            else
                uid_download();
        },
    },

    render() {
        return h(BarButton, {
            id: 'download-button',
            tippy: 'right',
            onClick: this.onClick,
            active: false,
            selected: this.state.tut_stage === 12,
            disabled: this.disabled,
            help: 'save_model',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(save_svg, this.alt),
            tooltip: DownloadTooltip,
        });
    },
});
